import $ from 'jquery';

const $buttons = $('.lehrplan-menu--ek-archive .button[data-year]');

$buttons.on('click', ev => {
    ev.preventDefault();
    const $button = $(ev.currentTarget);

    $buttons.removeClass('button--primary');
    $buttons.addClass('button--none');

    $button.removeClass('button--none');
    $button.addClass('button--primary');

    const year = parseInt($button.attr('data-year'));
    if (!year) {
        console.warn('No year found on button');
        return;
    }

    const $groups = $button.closest('.ek-archive').find('.ek-archive__group');
    const $next = $groups.filter(`.year-${year}`);
    $groups.addClass('ek-archive__group--hidden');
    window.setTimeout(() => {
        $groups.addClass('d-none');
        $next.removeClass('d-none');
        window.requestAnimationFrame(() => {
            $next.removeClass('ek-archive__group--hidden');
        });
    }, 300);

});
